import { SELECT_AN_OPTION_LABEL } from '../constants/common';

import { AsYouType } from 'libphonenumber-js';
export const scrollToTop = () => {
  window.scroll(0, 0);
};

export const isTrue = (value) => {
  return typeof value === 'boolean' ? value === true : value === 'true';
};

export const setSelectOption = (option, val) =>
  option && option !== SELECT_AN_OPTION_LABEL ? option : val;

export const randomKey = (length = 6) => {
  const chars =
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const arr = new Uint8Array(length);
  window.crypto.getRandomValues(arr);

  let result = '';

  for (const value of arr) {
    result += chars[value % chars.length];
  }

  return result;
};

export const stringToBool = (str) => str === 'true';

export const EMAIL_REGEX =
  /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

export const parseSearchParamsRaw = (queryString) => {
  // Remove leading '?' if present
  if (queryString.startsWith('?')) {
    queryString = queryString.slice(1);
  }

  const params = {};
  if (!queryString) {
    return params;
  }

  queryString.split('&').forEach((pair) => {
    const idx = pair.indexOf('=');
    if (idx === -1) {
      // No '=' present; treat entire pair as key with empty value
      params[pair] = '';
    } else {
      const key = pair.slice(0, idx);
      const value = pair.slice(idx + 1); // Everything after the first '='
      params[key] = value;
    }
  });

  return params;
};

export const getCountryCode = (input) => {
  if (!input) {
    return {
      formatted: '',
      withoutCountryCode: '',
      countryCode: '+973',
    };
  }
  // Set default country code to US if no real country code is specified
  if (!input?.startsWith('+')) {
    input = '+' + input;
  }
  const defaultCountryCode = input.substr(0, 1) !== '+' ? 'BH' : null;
  const asyo = new AsYouType(defaultCountryCode);
  let formatted = asyo.input(input === '' ? '+973' : input);
  let countryCode = '';

  countryCode = '+' + asyo.getCallingCode();

  return {
    formatted,
    withoutCountryCode: asyo.getNationalNumber(),
    countryCode,
  };
};

export const totalizer = {
  id: 'totalizer',
  beforeUpdate: (chart) => {
    let totals = {};
    let utmost = 0;
    chart.data.datasets.forEach((dataset, datasetIndex) => {
      if (chart.isDatasetVisible(datasetIndex)) {
        utmost = datasetIndex;
        dataset.data.forEach((value, index) => {
          totals[index] = (totals[index] || 0) + value;
        });
      }
    });
    chart.$totalizer = {
      totals: totals,
      utmost: utmost,
    };
  },
};

export const removeDuplicateAgreements = (data) => {
  // Only deduplicate agreements that:
  // 1) have the same `referenceNumber`
  // 2) `status` is 'Open'
  // 3) `reason` is 'Draft'
  // For those, keep the first occurrence and skip subsequent ones. If there are
  // multiple qualifying agreements for a referenceNumber, mark the kept one with
  // `isMultiple: true`.

  const result = [];
  const seen = {};

  // Count qualifying items per referenceNumber
  const qualifyingCount = data.reduce((acc, obj) => {
    const ref = obj.referenceNumber || '';
    const isQualifying = obj.status === 'Open' && obj.reason === 'Draft';
    if (isQualifying) {
      acc[ref] = (acc[ref] || 0) + 1;
    }
    return acc;
  }, {});

  data.forEach((obj) => {
    const ref = obj.referenceNumber || '';
    const isQualifying = obj.status === 'Open' && obj.reason === 'Draft';

    if (!isQualifying) {
      // Not eligible for deduplication — keep as-is
      result.push(obj);
      return;
    }

    // For qualifying items, only keep the first one per referenceNumber
    if (!seen[ref]) {
      const isMultiple = (qualifyingCount[ref] || 0) > 1;
      result.push({ ...obj, isMultiple });
      seen[ref] = true;
    }
    // else: skip duplicate qualifying item
  });

  return result;
};

export const getLocationPathname = () => window.location.pathname;
export const getLocationSearch = () => window.location.search;
export const locationReload = () => window.location.reload();
export const locationReplace = (url) => window.location.replace(url);
export const getLocationOrigin = () => window.location.origin;
